Object.isObject = function(value) {
  return value && (typeof value === 'undefined' ? 'undefined' : typeof (value)) === 'object' &&
    value.constructor === Object;
};

Date.timestamp = function() {
  return Math.floor(this.now() / 1000);
};
Date.prototype.addDays = function(num) {
  let value = this.valueOf();
  value += 86400000 * num;
  return new Date(value);
};

String.prototype.shuffle = function() {
  let a = this.split(''), n = a.length;
  for (let i = n - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    let tmp = a[i];
    a[i] = a[j];
    a[j] = tmp;
  }
  return a.join('');
};
String.prototype.slugify = function(join = '-') {
  return this.toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ç/g, 'c')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ö/g, 'o')
    .replace(/ş/g, 's')
    .replace(/ä/g, 'a')
    .replace(/ß/g, 'ss')
    .replace(/,./g, '')
    .replace(/_/g, ' ')
    .split(' ')
    .join(join);
};
String.prototype.capitalizeFirstLetter = function() {
  return this.charAt(0).toUpperCase() + this.slice(1);
};
String.prototype.hiddenDot = function() {
  return this.split(' ').map(ch => ch.trim()[0] + '*****').join(' ');
};

Number.prototype.format = function(indicator) {
  if (typeof indicator === 'undefined') {
    indicator = '.';
  }
  return this.toString().replace(/(.)(?=(?:\d{3})+$)/g, '$1' + indicator);
};
Number.prototype.isPrime = function() {
  if (parseInt(this) === 1) {
    return false;
  }
  for (let i = 2; i < this; i++) {
    if (this % i === 0) {
      return false;
    }
  }
  return this !== 1;
};

Array.prototype.random = function() {
  return this[Math.floor((Math.random() * this.length))];
};
Array.prototype.last = function() {
  return this[this.length - 1];
};
Array.prototype.remove = function(elem) {
  const indexOf = this.indexOf(elem);
  if (indexOf > -1) {
    return this.splice(indexOf, 1);
  }
};

Audio.prototype.play = (function(play) {
  return function() {
    const audio = this,
      args = arguments,
      promise = play.apply(audio, args);
    if (promise !== undefined) {
      promise.catch(_ => {
        document.addEventListener('click', function() {
          play.apply(audio, args);
        }, { once: true });
      });
    }
  };
})(Audio.prototype.play);

if (!Audio.prototype.stop) {
  Object.defineProperty(Audio.prototype, 'stop', {
    value: function(c) {
      this.pause();
      this.currentTime = 0;

      return this;
    },
    configurable: true,
    writable: true,
  });
}
if (!Audio.prototype.setVolume) {
  Object.defineProperty(Audio.prototype, 'setVolume', {
    value: function(volume) {
      this.volume = volume;
    },
    configurable: true,
    writable: true,
  });
}

if (!String.prototype.mtrim) {
  Object.defineProperty(String.prototype, 'mtrim', {
    value: function() {
      return this.replace(/\s+\$/,
        '',
      ) // [\r\n\t\f\v ]) karakterlerini sıfırlamak için Büyük küçük harf ile birlikte
        .replace(/—|–|—|–/g, '-') // fontlarda bulunan farklı tireleri güncellemek için
        .replace(/[^-ıIüöäÄß\w\s]/gi,
          '',
        ) // - ile ß arasındaki karakterler hariç harf olmayan karakterleri silmek için
        .replace(/\s\s+/g, ' ') // çoklu boşlukları teke indirmek için
        .trim(); // sondaki ve baştaki boşlukları silmek için
    },
    configurable: true,
    writable: true,
  });
}
if (!String.prototype.replaceAll) {
  Object.defineProperty(String.prototype, 'replaceAll', {
    value: function(find, replace) {
      let s = '', index, next;
      while (~(next = this.indexOf(find, index))) {
        s += this.substring(index, next) + replace;
        index = next + find.length;
      }
      return s + this.substring(index);
    },
    configurable: true,
    writable: true,
  });
}

if (!Array.prototype.chunkBy) {
  Object.defineProperty(Array.prototype, 'chunkBy', {
    value: function(c) {
      if (!c) { return [].concat(this); }
      let arr = [];
      for (let i = 0, j = this.length; i < j; i += c) {
        arr.push(this.slice(i, i + c));
      }
      return arr;
    },
    configurable: true,
    writable: true,
  });
}

// https://tc39.github.io/ecma262/#sec-array.prototype.findindex
if (!Array.prototype.findIndex) {
  Object.defineProperty(Array.prototype, 'findIndex', {
    value: function(predicate) {
      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      let o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      let len = o.length >>> 0;

      // 3. If IsCallable(predicate) is false, throw a TypeError exception.
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }

      // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
      let thisArg = arguments[1];

      // 5. Let k be 0.
      let k = 0;

      // 6. Repeat, while k < len
      while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return k.
        let kValue = o[k];
        if (predicate.call(thisArg, kValue, k, o)) {
          return k;
        }
        // e. Increase k by 1.
        k++;
      }

      // 7. Return -1.
      return -1;
    },
    configurable: true,
    writable: true
  });
}
